module.exports = "<div class=\"modal-content\">\r\n  <div class=\"modal-header\">\r\n    <h3 class=\"modal-title\">Transaction Details</h3>\r\n  </div>\r\n  <div class=\"modal-body\">\r\n    <pre class=\"pre-scrollable\">{{ details }}</pre>\r\n  </div>\r\n  <div class=\"modal-footer\">\r\n    <button class=\"btn btn-warning\" type=\"button\" (click)=\"close()\">Close</button>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/paymentTransactions/components/templates/transactionModal.component.html
// module id = ./src/app/paymentTransactions/components/templates/transactionModal.component.html
// module chunks = main